/**
 * 上架模板「平台」统一为内部枚举值，与校验 / 预览逻辑一致。
 * 兼容 UI 或历史数据中的别名（如 TEMU半托管）。
 */
export function canonicalListingTemplatePlatform(raw) {
  const p = String(raw || '').trim();
  if (!p) return '';
  const map = {
    TEMU半托管: 'TEMU半托',
    'TEMU 半托': 'TEMU半托',
    'TEMU 半托管': 'TEMU半托',
    SHEIN半托管: 'SHEIN半托',
    'SHEIN 半托': 'SHEIN半托',
    'SHEIN 半托管': 'SHEIN半托',
    SHEIN: 'SHEIN半托',
    Shein: 'SHEIN半托',
  };
  return map[p] || p;
}

export const LISTING_TEMPLATE_KIND_TABLE = 'table';
export const LISTING_TEMPLATE_KIND_PUBLISH = 'publish';
/** @deprecated 平台「商品模板」Tab 已下线；历史 product 按表格模板处理 */
export const LISTING_TEMPLATE_KIND_PRODUCT = 'product';

export function resolveListingTemplateKind(template) {
  const kind = template?.templateKind || template?.template_kind;
  return coerceListingTemplateKind(kind, LISTING_TEMPLATE_KIND_TABLE);
}

/** 保存 / 路由：保留 publish、table；product 归并为 table；未知值回退 fallback */
export function coerceListingTemplateKind(raw, fallback = LISTING_TEMPLATE_KIND_TABLE) {
  const k = String(raw || '').trim();
  if (k === LISTING_TEMPLATE_KIND_PUBLISH) return LISTING_TEMPLATE_KIND_PUBLISH;
  if (k === LISTING_TEMPLATE_KIND_PRODUCT) return LISTING_TEMPLATE_KIND_TABLE;
  if (k === LISTING_TEMPLATE_KIND_TABLE) return LISTING_TEMPLATE_KIND_TABLE;
  return fallback;
}

export function listingTemplateNavForKind(kind) {
  if (kind === LISTING_TEMPLATE_KIND_PUBLISH) return 'listingTemplates';
  return 'tableTemplates';
}

export function listingTemplateDataKeyForKind(kind) {
  if (kind === LISTING_TEMPLATE_KIND_PUBLISH) return 'listingTemplates';
  return 'tableTemplates';
}

export function listingTemplateLabelForKind(kind) {
  if (kind === LISTING_TEMPLATE_KIND_PUBLISH) return '刊登模板';
  return '表格模板';
}

/** 表格 / 刊登模板（共用 listing-templates 目录与列表 UI） */
export function isListingCatalogTemplateNav(navId) {
  return navId === 'tableTemplates' || navId === 'listingTemplates';
}

/** 表格模板（Excel 导出），不含平台直接刊登模板 */
export function isTableListingTemplate(template) {
  return resolveListingTemplateKind(template) === LISTING_TEMPLATE_KIND_TABLE;
}

export function filterTableListingTemplates(templates) {
  return (templates || []).filter(isTableListingTemplate);
}
